import type { BrandTheme, PartialBrandTheme } from '../../types/BrandTheme'
import { merge } from 'theme-ui'
import { dirname } from 'path'
import { elkjoptheme } from '../elkjop/elkjop.theme'

import './theme.css'

export const giganttitheme: BrandTheme = merge.all<
  BrandTheme,
  PartialBrandTheme
>(elkjoptheme, {
  branding: {
    brand: 'GIGANTTI',
    themedir: dirname(new URL(import.meta.url).pathname),
    staticDir: 'gigantti',
    height: 32,
    learnMoreLinkWaitlist: 8031274,
    learnMoreLinkSearch: 8041936,
  },
})
export default giganttitheme
